import { useEffect } from "react";
import './Privacy.css';
export default function Privacy() {
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth" // Smooth scrolling animation
        });
      }
      
      
      useEffect(() => {
        scrollToTop();
      }, []);
    return(
        <>
          <section class="banner">
    <h1>The privacy policy</h1>
  </section>
        <div className="container-terms">
<h1 className="title-terms">Information Collection</h1>
<p className="description-terms">We collect some personal information from users who visit our website and use our services. This information may include names, email addresses, phone numbers, addresses, and financial information (in the case of purchases or sales).</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">Use of Information</h1>
<p className="description-terms">We will use the personal information we collect to provide services and products that are relevant to users. We may use the information to customize and improve the user experience, enhance our services, analyze data and statistics, and communicate with users about new products, services, or special offers.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">Protection of Information</h1>
<p className="description-terms">We take reasonable security measures to protect the personal information we collect from unauthorized access, use, or disclosure. However, we cannot guarantee complete security, and therefore we are not responsible for any loss or damage resulting from unauthorized access to personal information.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">Sharing of Information</h1>
<p className="description-terms">We may share personal information with limited third parties if it is necessary to provide the services and products requested by users. For example, we may share information with real estate agents, banks, or transportation companies to complete a purchase or sale of apartments.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">Cookies</h1>
<p className="description-terms">We may use cookies and similar technologies to collect non-personal information about users and enhance their experience on the website. Users can disable cookies in their browser settings, but this may reduce some website functionality.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">Changes to the Privacy Policy</h1>
<p className="description-terms">We may update the privacy policy from time to time to reflect changes in our practices or legal requirements. Any changes will be published on the website.</p>
        </div>
        </>
    )
}